import styled from 'styled-components'

import { SvgImage } from 'components/SvgImage'

import { Color } from 'root-constants'

export const StyledIgnoredSigns = {
  Wrapper: styled.div`
    display: flex;
    flex-direction: column;
    gap: 24px;
  `,
  Title: styled.p`
    font-size: 24px;
    font-weight: 700;
    line-height: 32px;
    text-align: center;
    color: ${Color.INK_DARKEST};
  `,
  List: styled.div`
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 8px;
  `,
  Sign: styled.div`
    display: flex;
    align-items: center;
    gap: 6px;

    border-radius: 16px;
    background: ${Color.PINK_LIGHT};

    padding: 12px;
  `,
  SignIcon: styled(SvgImage)`
    flex-shrink: 0;
  `,
  SignTitle: styled.p`
    min-width: 0;
    overflow-wrap: break-word;

    font-size: 14px;
    font-weight: 700;
    line-height: 18px;
    color: ${Color.INK_DARKEST};
  `,
}
